import { render, staticRenderFns } from "./CreateFeaturedImage.vue?vue&type=template&id=1d296cd2"
import script from "./CreateFeaturedImage.vue?vue&type=script&lang=js"
export * from "./CreateFeaturedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports